









































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { PatternBaseLayer } from "@/model/document2/page/surface/design/layer/patternBaseLayer";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import RadioOn from "../resources/radioOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      ArrowDown,
      ArrowRight,
      RadioOn
  }
})
export default class PatternColorFillNone extends Vue {
  @Prop()
  private layer!: PatternBaseLayer;

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  //こいつはpropsでもらいたい
  openStatus = {
    opend: true
  };

  patternColorFillNoneContentsOpenAnimate = false;
  patternColorFillNoneContentsCloseAnimate = false;

  open() {
    if (this.openStatus.opend) {
      this.patternColorFillNoneContentsCloseAnimate = true;
      setTimeout(() => {
        this.patternColorFillNoneContentsCloseAnimate = false;
        this.patternColorFillNoneContentsOpenAnimate = false;
        this.openStatus.opend = false;
      }, 200);
    } else {
      this.openStatus.opend = true;
      this.patternColorFillNoneContentsOpenAnimate = true;
      setTimeout(() => {
        this.patternColorFillNoneContentsOpenAnimate = false;
      }, 250);
    }
  }
  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

  private changeFillType(fillType: string) {
    var layerFillType = 0;
    if (fillType == "none") {
      layerFillType = 0;
    } else if (fillType == "solid") {
      layerFillType = 1;
    } else if (fillType == "gradient") {
      layerFillType = 2;
    }

    this.changeLayerProperty("fillType", layerFillType);
  }

  private changeLayerProperty(propertyName: string, value: any) {
    this.$emit("doCommand", "changeLayerProperty", {
      layer: this.layer,
      propertyName: propertyName,
      value: value
    });
  }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
